export const encodeFileName = (title: string) => {
    return title.replace(/[<>:"/\\|?*]+/g, '').replace(/\s+/g, '');
};

export const downloadFile = (downloadLink: string, fileName: string) => {
    const a = document.createElement('a');
    a.download = encodeFileName(fileName);
    a.href = downloadLink;
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
};


export const downloadFileFromBlob = (blob: Blob, fileName: string) => {
    const a = document.createElement('a');
    a.download = encodeFileName(fileName);
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
};

export const exportToZip = (data: string, fileName: string) => {
    // Convert array buffer to Base64
    const binary_string = window.atob(data);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }

    // Convert Base64 string to dataURL
    const file = new Blob([bytes], {
        type: 'application/zip',
    });

    downloadFileFromBlob(file, fileName);
};